<script>
 export let dateString; // The ISO date string from your API (e.g., "2023-10-27T14:30:00Z")
 export let dateStyle = 'long'; // 'full', 'long', 'medium', 'short'
 export let timeStyle = 'short'; // 'full', 'long', 'medium', 'short'

 let formattedDate = '';

 // A reactive statement that re-runs whenever the props change
 $: {
     if (dateString) {
         try {
             const date = new Date(dateString);

             // Create a formatter for the Greek locale ('el-GR')
             const formatter = new Intl.DateTimeFormat('el-GR', {
                 dateStyle: dateStyle,
                 timeStyle: timeStyle,
                 // Optional: specify timezone if needed
                 // timeZone: 'Europe/Athens', 
             });

             formattedDate = formatter.format(date);
         } catch (error) {
             console.error("Invalid date string provided:", dateString);
             formattedDate = "Invalid Date";
         }
     }
 }
</script>

<!-- The <time> tag is semantically correct for displaying dates -->
<!-- The datetime attribute should contain the machine-readable ISO string -->
<time datetime={dateString}>
    {formattedDate}
</time>
